<template>
  <WdsStack gap-sm direction-column class="filter-full-width">
    <WdsSelect
      v-model="selectedClients"
      multi-select
      searchable
      class="tw-min-w-[250px]"
      :label="meta.filter.quickFilter ? '' : $t('Client')"
      :list="clients"
      :placeholder="$t('All clients')"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 5"
      can-deselect
      labels-primary
    >
      <template #select-all-text>
        <WdsText :text="$t('Select all')" />
      </template>
    </WdsSelect>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack, WdsText } from '@worksome/wds-components'
import { computed, ComputedRef, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { ListItem } from '@/components/Workflows/Pages/Workflow/workflow'
import { graphql } from '@/gql'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

type ClientFilter = ListItem & { id: string }

const { meta } = defineProps<{ meta: FilterMetaDataProp }>()

const selectedClients: ModelRef<ClientFilter[]> = defineModel({
  default: () => [],
})

// The client companies the current account has hires for. Scoped to the
// authenticated account (the partner) — no `accounts` argument is passed.
const { result } = useQuery(
  graphql(`
    query PaymentRequestClientsFilter {
      hires(first: 100000) {
        data {
          id
          company {
            id
            value: id
            label: name
          }
        }
      }
    }
  `),
  () => ({}),
  {
    clientId: 'publicApi',
  },
)

const clients: ComputedRef<ClientFilter[]> = computed(() => [
  ...new Map(
    (result.value?.hires.data.map(({ company }) => company) ?? []).map((company) => [
      company.id,
      company,
    ]),
  ).values(),
])
</script>
